<template lang="pug">
v-card.comments-card(tile, width="350px", data-cy="comments__card")
  v-card-title.pt-6.pr-6.primary.white--text.align-center
    h3 {{ $tc('Comment._name', 2).toUpperCase() }}
    v-spacer
    g-btn(icon, dark, height="14px", width="14px")
      v-icon(@click="$emit('hide')") mdi-close
  h12.pa-3.text-right
    a.icon--text(@click="$emit('markAll')") {{ $t('commentCard.markAll') }}
  v-list.pa-0
    v-divider
    template(v-if="loading")
      v-skeleton-loader(max-height="90px", type="list-item-three-line")
    template(v-else)
      template(v-for="tag in tags")
        v-list-item.comment(three-line)
          v-list-item-content.comment__content(@click="commentClick(tag)")
            v-list-item-title.d-flex
              h9 {{ $t('commentCard.commentBy', { author: get(tag, 'comment.user.fullName') }) }}
              v-spacer
              h9 {{ $formattedDate(get(tag, 'comment.createdAt')) }}
            v-list-item-subtitle.d-flex(style="max-height: 28px;")
              h10.comment__description(v-html="get(tag, 'comment.commentText')")
              v-spacer
              v-icon.ml-6.primary--text(@click="commentClick(tag, false, $event)") mdi-eye
        v-divider
  v-card-actions.align-center.justify-center(style="height: 70px;")
    g-btn(:disabled="loading", outlined, color="primary", @click="$emit('more')") {{ $t('commentCard.more') }}
</template>

<style lang="scss" scoped>
.comment {
  &__content {
    cursor: pointer;
  }
  &__description {
    overflow: hidden;
  }
}
</style>

<script>
import axios from 'axios';
import get from 'lodash/get';

export default {
  props: {
    tags: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  methods: {
    get: get,
    async commentClick(tag, redirect = true, e) {
      if(e) e.stopPropagation();
      try {
        await axios.put(`/Tag/${tag.uid}`, { isRead: 1 });
        if (redirect) {
          // FORCE rerendering of order component if editing another order
          // Clean url so the second push appends as expected
          await this.$router.push('/')
          this.$router.push({ path: this.$scope() + `/${tag.comment.commentEntity}/${tag.comment.commentEntityUid}/edit?fromComments=true`});
          this.$emit('hide');
        } else {
          this.$emit('reload');
        }
      } catch (e) {
        console.log(this.$cleanString(e));
      }
    },
    log(val, e) {
      if(e) e.stopPropagation();
      console.log(this.$cleanString(val));
    },
  },
}
</script>
